module.exports = __webpack_public_path__ + "img/id.7b9fcd93.svg";